/* eslint-disable @typescript-eslint/explicit-function-return-type */

import {
    enableProdMode,
    importProvidersFrom,
    provideZoneChangeDetection,
} from '@angular/core';

import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
    withXsrfConfiguration,
} from '@angular/common/http';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule, Title, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DevExtremeModule, DxAccordionModule } from 'devextreme-angular';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { MomentModule } from 'ngx-moment';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent, CustomInterceptor } from './app/app.component';
import { ComponentModule } from './app/core/components/components.module';
import { environment } from './environments/environment';
import config from 'devextreme/core/config';

// Store original console methods before any modifications
const originalConsole = {
    log: console.log,
    debug: console.debug,
    info: console.info,
    warn: console.warn,
    error: console.error,
};

if (environment.production) {
    // In production, disable console logging by default
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
    // Keep warn and error always enabled for important messages
    enableProdMode();
} else {
    console.log('NOT PRODUCTION MODE ###########');
}

// Global function to enable logging for admin users in production ^^ it will be useful for sure :-p
(window as any).enableAdminLogging = function (user: any) {
    if (environment.production && user && user.access_level === 1) {
        console.log = originalConsole.log;
        console.debug = originalConsole.debug;
        console.info = originalConsole.info;
        console.warn = originalConsole.warn;
        console.log(
            '🔑 [Admin Logging] Console logging enabled for admin user:',
            user.user_id
        );
    }
};

// Global function to disable logging (for logout)
(window as any).disableAdminLogging = function () {
    if (environment.production) {
        console.log = () => {};
        console.debug = () => {};
        console.info = () => {};
    }
};

config({ licenseKey: environment.licenseKey, editorStylingMode: 'underlined' });

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(
            ComponentModule.forRoot(),
            CommonModule,
            BrowserModule,
            AppRoutingModule,
            DxAccordionModule,
            MomentModule,
            ModalModule.forRoot(),
            NgbModule,
            DevExtremeModule,
            ProgressbarModule.forRoot(),
            MatExpansionModule,
            MatSelectModule,
            MatFormFieldModule,
            MatGridListModule,
            MatToolbarModule,
            MatProgressSpinnerModule
        ),
        Title,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: CustomInterceptor, multi: true },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideHttpClient(
            withXsrfConfiguration({
                cookieName: 'pulse.x-csrf-token',
                headerName: 'x-csrf-token',
            })
        ),
        //provideExperimentalZonelessChangeDetection() // --> TODO the day we want to remove polyfills ...
    ],
}).catch(err => console.log(err));
